var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({class:_vm.activatorClass},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.getAttrs,false),_vm.$listeners),[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getText))])])}
var staticRenderFns = []

export { render, staticRenderFns }